<template>
    <main class="pt-5">
        <v-container>

                <!--Grid row-->
                <v-row>
                    <v-col class="my-4">
                        <v-card elevation="4" class="white">

                            <v-alert text prominent type="info" class="text-left text-h5">
                                <b>Thank you for your interest in SCMP Group Subscriptions</b><br>It looks like the promotion you are looking for has expired. For more information please contact us at <a href="mailto:groupsubs@scmp.com">groupsubs@scmp.com</a>
                            </v-alert>
                        </v-card>
                    </v-col>
                </v-row>


        </v-container>
    </main>
</template>

<script>

export default {
    name: 'Ended',
    components: {
    },
    data() {

        return {


        };
    },
    computed: {

    },
    created(){

    },
    mounted(){

    },
    methods: {

    }
}

</script>
